<template>
  <div class="Rectangle-1908" @click="textClicked">
    <div class="text-container">
      <ProcessedPostText readMoreColor="white" :content="content" />
    </div>
  </div>
</template>

<script>
import ProcessedPostText from "./processed-text.vue";

export default {
  name: "TextOverlay",
  components: {
    ProcessedPostText: ProcessedPostText,
  },
  props: {
    content: {
      type: String,
    },
  },
  data() {
    return {
      isTextClicked: false
    }
  },
  methods: {
    textClicked() {
      this.isTextClicked = !this.isTextClicked
      if (!this.isTextClicked) {
          this.$emit("is_media_clicked", {'is_media_played': this.isTextClicked});
      } else {
          this.$emit("is_media_clicked", {'is_media_played': this.isTextClicked});
      }
    },
  }
};
</script>

<style scoped>

.Rectangle-1908 {
  max-height: 50vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  overflow-wrap: break-word;
  background-image: linear-gradient(141deg, #2979fc 2%, #24c5d4 91%);
  color: white;
}

.text-container {
  width: 100%;
}

@media only screen and (min-width: 50px) {
  .Rectangle-1908 {
    font-size: 1.5em;
    height: 20rem;
    padding: 1.5rem;
  }
}

@media only screen and (min-width: 400px) {
  .Rectangle-1908 {
    font-size: 1.5em;
    height: 30rem;
    padding: 1.5rem;
  }
}

@media only screen and (min-width: 450px) {
}

@media only screen and (min-width: 650px) {
}

@media only screen and (min-width: 800px) {
}

@media only screen and (min-height: 1024px) {
}
</style>